import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
/** The option's key, in the URL too: /?sort=unanswered. */
const UNANSWERED = 'unanswered';

/** Core's own sorts, which stay first in the dropdown. */
const CORE_SORTS = ['relevance', 'latest', 'top', 'newest', 'oldest', 'az', 'za'];

/**
 * Not on the pages of the forums the filter leaves out (articles, events,
 * galleries... see UnansweredFilter), nor of their sub-forums, where it
 * could only ever list nothing. A tag still loading keeps it: the server's
 * filter gives the right list either way.
 */
function offeredHere() {
  if (!m.route.param('tags')) return true;
  const excluded = app.forum.attribute('unansweredExcludedTagIds') || [];
  let tag = app.currentTag?.();
  for (; tag; tag = tag.parent()) {
    if (excluded.includes(tag.id())) return false;
  }
  return true;
}

/**
 * "Sans réponse" in the discussion list's "Activité" dropdown: only the
 * discussions nobody has replied to yet, phpBB's "Sujets sans réponse", by
 * latest activity - on the home page and the forum pages where it applies.
 *
 * Same approach as champis-species' "En attente de détermination"
 * (addMissingSpeciesSort.ts): the server knows nothing of this sort, so
 * the entry stands for the default order plus filter[unanswered]
 * (UnansweredFilter). Only on the home and forum pages' list
 * (app.discussions), not on a species page's own.
 */
export default function addUnansweredSort() {
  extend(DiscussionListState.prototype, 'sortMap', function (map) {
    if (this !== app.discussions || !offeredHere()) return;

    // Right after core's sorts, before the other extensions' filters
    // ("En attente de détermination"): taken out, then put back after it.
    const later = Object.keys(map).filter(key => !CORE_SORTS.includes(key)).map(key => {
      const item = map[key];
      delete map[key];
      return [key, item];
    });
    map[UNANSWERED] = {
      sort: '-lastPostedAt',
      label: app.translator.trans('champis-forum.forum.index_sort.unanswered_button')
    };
    later.forEach(_ref => {
      let [key, item] = _ref;
      return map[key] = item;
    });
  });
  extend(DiscussionListState.prototype, 'requestParams', function (params) {
    // Where it isn't offered, a ?sort=unanswered left in the URL is
    // ignored, like any unknown sort: the list matches the dropdown.
    if (this !== app.discussions || this.getSort() !== UNANSWERED || !(UNANSWERED in this.sortMap())) return;
    params.filter = {
      ...params.filter,
      unanswered: '1'
    };
  });

  // On a page load, the server preloads the list it knows - unfiltered:
  // dropped, so that the list is fetched with the filter.
  override(IndexPage.prototype, 'oninit', function (original, vnode) {
    if (m.route.param('sort') === UNANSWERED) app.preloadedApiDocument();
    original(vnode);
  });
}